!<!--  -->
<template>
  <div
    class="wrap_R"
    :style="{ height: myHeight }"
    :class="auto_fixed ? 'auto_fixed' : 'w750'"
  >
  <div>
    <p
      style="
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #343434;
      "
    >
      {{$t('i18n_cost_calculation')}}
    </p>
    <!-- 海运费 -->
    <div class="Item_Right animate__animated animate__fadeInRight">
      <p class="tit">{{$t('i18n_shipping_cost')}}</p>
      <p
        class="coutText"
        v-for="(item, index) in transportFeeForAir.goodsTypeFeeDTOS"
        :key="index"
      >
        <span class="littit">{{ item.goodsTypeName }}</span>
        <span class="fontString">{{ item.currency }}{{ item.amount }}</span>
        <span style="margin-left: 10px">({{ item.calDesc }})</span>
      </p>
      <p class="coutText">
        <span class="littit">{{$t('i18n_subtotal')}}</span>
        <span class="fontString"
          >{{ transportFeeForAir.currency
          }}{{ transportFeeForAir.amount || "0.00" }}</span
        >
      </p>
    </div>
    <!-- 海运费end -->
    <!-- 提货费 -->
    <transition enter-active-class="animate__animated animate__fadeInRight" leave-active-class="animate__animated animate__fadeOutRight">
      <div
        class="Item_Right"
        v-show="pickFeeChecked"
      >
        <p class="tit" style="display: flex; justify-content: space-between">
          <span>{{$t('i18n_pickup_fee')}}</span>
          <span
            v-if="
              pickFeeForAir.minKilometer != null &&
              pickFeeForAir.maxKilometer != null
            "
            s
            tyle="font-size:13px;font-weight: 500;"
          >
            ({{ pickFeeForAir.minKilometer + "KM" }}
            --
            {{ pickFeeForAir.maxKilometer + "KM" }})
          </span>
        </p>
        <p class="coutText">
          <span class="littit">{{$t('i18n_pickup_at_original_port')}}</span>
          <span class="fontString"> CNY {{ pickFeeForAir.cnyamount || '0.00' }}</span>
        </p>
      </div>
    </transition>
    <!-- 提货费end -->
    <!-- 配送费 -->
    <!-- <div
      class="Item_Right animate__animated animate__fadeInRight"
      v-show="sendFeeChecked "
    >
      <p class="tit">配送费</p>
      <p class="coutText">
        <span class="littit">目的地送货上门</span>
        <span class="fontString">
          {{ sendFeeForAir.currency }}
          CNY
          {{ sendFeeForAir.cnyprice || '0.00' }}</span
        >
      </p>
    </div> -->
    <!-- 配送费end -->

    <!-- 增值服务费用 -->
    <div
      style="height: 110px; overflow: auto"
      id="moreFee"
      class="OrderDetails Item_Right animate__animated animate__bounceInRight"
      v-if="allMoreFeeInfo.amount > 0"
    >
      <p class="" style="display: flex; justify-content: space-between">
        <span class="tit" style="width: 100px">增值服务费用</span>
        <span class="fontString"></span>
      </p>
      <div v-for="(item, index) in feeList" :key="index">
        <p class="coutText" v-if="item.checked">
          <span class="littit">{{ item.feeName }}</span>
          <span class="fontString animate__animated animate__bounceInRight"
            >{{ item.currency }}{{ item.amount }}</span
          >
        </p>
        <!-- 手续费另外显示 -->
        <p class="coutText" v-if="item.checked && item.amount2">
          <span class="littit">{{ item.feeName }}手续费</span>
          <span class="fontString">{{ item.currency }}{{ item.amount2 }}</span>
        </p>
      </div>
      <p class="coutText">
        <span class="littit">{{$t('i18n_subtotal')}}</span>
        <span class="fontString" style="text-align: right">
          {{ allMoreFeeInfo.totalExpense }}</span
        >
      </p>
    </div>
    <!-- 增值服务费用end -->

    <!-- 合计费用 -->
    <div class="Item_Right">
      <p class="" style="display: flex; justify-content: space-between">
        <span class="littit" style="width: 100px">{{$t('i18n_total_cost')}}</span>
        <span class="fontString" style="text-align: right">{{
          currencyCollection
        }}</span>
      </p>
      <p class="coutText">
        <span class="littit">{{$t('i18n_Covert_to_CNY')}}</span>
        <span class="fontString">CNY {{ calculatePrice }}</span>
      </p>
    </div>
    </div>
    <!-- 合计费用end -->

    <!-- 上下步 -->
    <div style="width: 100%; float: left">
      <div style="width: 100%">
        <!-- <el-button style="width: 100%" @click="pathToback()">上一步</el-button> -->
      </div>
      <div style="width: 100%; margin-top: 10px">
        <el-button
          style="width: 100%; background: #5AB53C; color: #ffffff"
          @click="submitOrder"
        >
          {{$t('i18n_submit_order')}} </el-button
        >
      </div>
    </div>
    <!-- 上下步end -->
  </div>
</template>

<script>
export default {
  props: {
    isLastStep: {
      type: Boolean,
      default: false,
    },
    auto_fixed: {
      type: Boolean,
      default: false,
    },
    feeList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    allMoreFeeInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    transportFeeForAir: {
      type: Object,
      default: () => {
        return {};
      },
    },
    pickFeeForAir: {
      type: Object,
      default: () => {
        return {};
      },
    },
    // sendFeeForAir: {
    //   type: Object,
    //   default: () => {
    //     return {};
    //   },
    // },
    currencyCollection: {
      type: String,
      default: "",
    },
    calculatePrice: {
      type: String,
      default: "",
    },
    pickFeeChecked: {
      type: Boolean,
      default: true
    },
    sendFeeChecked: {
      type: Boolean,
      default: true
    }
  },
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      // feeList:[]
    };
  },
  //监听属性 类似于data概念
  watch: {
    // feeList:{
    //    handler:function(val,oldval){
    //       console.log(11)
    //     },
    //      deep: true,
    // }
  },
  computed: {
    myHeight() {
      let num = 400;
      // if(this.sendFeeForAir.checked){
      //     num+=80
      // }
      // if(this.pickFeeForAir.checked){
      //     num+=80
      // }
      // this.feeList.forEach((item,index) =>{
      //       if(item.checked){
      //          if(index == 0){
      //               num += 80
      //          }else{
      //               num += 40
      //          }
      //       }
      // })
      return `${num}px`;
    },
  },
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    getIndex(index) {
      // console.log(index);
    },
    // pathToback() {
    //   this.$emit("pathToback");
    // },
    // pathToNext() {
    //   this.$emit("pathToNext", "ruleform");
    // },
    submitOrder() {
      this.$emit('submitOrder')
    },
    getHeight(index) {
      console.log(index);
      let moreFeeDom = document.getElementById("moreFee");
      // let divList = moreFeeDom && moreFeeDom.querySelectorAll('div')
      // if(index === false){
        
      if (moreFeeDom) {
        // console.log(moreFeeDom.scrollTop);
        moreFeeDom.scrollTop = moreFeeDom.offsetTop
      }
      console.dir(moreFeeDom);

      //   return
      // }
      // if(moreFeeDom){
      //    console.log(moreFeeDom.scrollTop =  divList[index].offsetTop);
      // console.log(moreFeeDom.querySelectorAll('div'))
      // }
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.getHeight();
    // console.log(this.feeList);
  },
};
</script>
<style  scoped>
/* table 滚动条 */
/* .OrderDetails {
  max-height: 500px;
  overflow: auto;
  overflow-x: hidden;
} */
.OrderDetails::-webkit-scrollbar {
  width: 3px;
}
.OrderDetails::-webkit-scrollbar-thumb {
  background: #409eff;
}
/* .OrderDetails::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 2px;
  background: #eee;
} */

.auto_fixed {
  position: fixed;
  top: 80px;
  margin-left: 778px;
  z-index: 100;
}
/* .w750 {
  height: 750px!important;
} */
.fontString {
  font-weight: bold;
}

.coutText {
  margin-top: 9px;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #343434;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  overflow-x: hidden;
}
.wrap_R {
  /* float: right; */
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 320px;
  background: #ffffff;
  box-shadow: 0px 0px 20px 0px rgba(193, 193, 193, 0.21);
  border-radius: 10px;
  padding: 20px;
  box-sizing: border-box;
  position: sticky;
  top: 15px;
}
.Item_Right {
  width: 100%;
  float: left;
  padding: 15px 0;
  box-sizing: border-box;
  border-bottom: 1px solid #e7e7e7;
}
.littit {
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #999999;
}
.tit {
  font-size: 14px;
  font-family: PingFang SC;
}
</style>


// WEBPACK FOOTER //
// src/components/airOrder/component/fee-detail.vue